// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-portable-power-station_productcontent__dDQ7X"};